'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { MouseEvent } from 'react';
import AppLink from '@/components/elementary/AppLink';
import { isDefaultLocale, sortLocaleLinksByAppLocales } from '@/components/elementary/LocaleSwitcher/utils';
import { ButtonGroup } from '@/components/ui/button-group';
import { LOCALE_TRANSLATION } from '@/constants/i18n.constants';
import { cn } from '@/lib/styles';
import type { AppLocale } from '@/types/general';
import type { LocaleLink } from '@/types/i18n.types';
type Props = {
  currentLocale: AppLocale;
  localeLinks: LocaleLink[];
  onLocaleChange?: (locale: AppLocale) => void;
};
export function MobileLocaleSwitcher(t0) {
  const $ = _c(22);
  const {
    currentLocale,
    localeLinks,
    onLocaleChange
  } = t0;
  const t = useTranslations("LocaleSwitcher");
  let t1;
  if ($[0] !== onLocaleChange) {
    t1 = locale => event => {
      if (!onLocaleChange) {
        return;
      }
      event.preventDefault();
      onLocaleChange(locale);
    };
    $[0] = onLocaleChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLocaleLinkClick = t1;
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] !== currentLocale || $[3] !== handleLocaleLinkClick || $[4] !== localeLinks || $[5] !== t) {
    const sortedLinks = sortLocaleLinksByAppLocales(localeLinks);
    T0 = ButtonGroup;
    if ($[11] !== t) {
      t2 = t("selectLanguage");
      $[11] = t;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    t3 = "horizontal";
    t4 = "w-full";
    let t6;
    if ($[13] !== currentLocale || $[14] !== handleLocaleLinkClick) {
      t6 = link => {
        const isActive = link.locale === currentLocale;
        const useNativeAnchor = isDefaultLocale(link.locale);
        return isActive ? <span key={link.locale} aria-current="true" className={cn("lok-text-body-bold-large bg-wolf-gray-100", "flex-1 inline-flex items-center justify-center h-12 rounded-sm border border-wolf-gray-500 text-wolf-gray-950 uppercase")}>{link.locale}</span> : <AppLink key={link.locale} href={link.pathname} locale={link.locale} forceAnchor={useNativeAnchor} variant="none" size="none" aria-label={LOCALE_TRANSLATION[link.locale as keyof typeof LOCALE_TRANSLATION]} className={cn("lok-text-body-regular-large", "flex-1 inline-flex items-center justify-center h-12 rounded-sm border border-wolf-gray-500 text-wolf-gray-950 uppercase")} onClick={handleLocaleLinkClick(link.locale)}>{link.locale}</AppLink>;
      };
      $[13] = currentLocale;
      $[14] = handleLocaleLinkClick;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t5 = sortedLinks.map(t6);
    $[2] = currentLocale;
    $[3] = handleLocaleLinkClick;
    $[4] = localeLinks;
    $[5] = t;
    $[6] = T0;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    T0 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[16] !== T0 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5) {
    t6 = <T0 aria-label={t2} orientation={t3} className={t4}>{t5}</T0>;
    $[16] = T0;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}